export default __webpack_public_path__ + "static/media/sass.d0d03348.svg";